var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNbWifiDesktop(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 50 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C31F14B0-52AF-4EA8-910C-553B1E3D8EC6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-wifi-access-create1",
    transform: "translate(-116.000000, -424.000000)",
    fill: "#76778C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.877131,424.406348 C118.645557,424.406348 116,427.067244 116,430.339515 L116,456.337574 C116,459.609863 118.645557,462.28872 121.877131,462.28872 L133.453835,462.28872 L130.914773,466.981316 L123.93679,466.981316 C123.895391,466.97902 123.853899,466.97902 123.8125,466.981316 C123.406487,467.003758 123.043144,467.243843 122.859356,467.611122 C122.675567,467.978402 122.699258,468.417069 122.921504,468.761864 C123.14375,469.106658 123.530781,469.30519 123.93679,469.282666 L158.06321,469.282666 C158.473023,469.288533 158.854209,469.070508 159.060807,468.712076 C159.267404,468.353644 159.267404,467.910337 159.060807,467.551906 C158.854209,467.193474 158.473023,466.975449 158.06321,466.981316 L151.085227,466.981316 L148.546165,462.28872 L160.122869,462.28872 C163.354443,462.28872 166,459.609863 166,456.337574 L166,430.339515 C166,427.067244 163.354443,424.406348 160.122869,424.406348 L121.877131,424.406348 Z M121.877131,426.707698 L160.122869,426.707698 C162.134664,426.707698 163.727273,428.302384 163.727273,430.339515 L163.727273,452.975446 L118.272727,452.975446 L118.272727,430.339515 C118.272727,428.302384 119.865336,426.707698 121.877131,426.707698 Z M118.272727,455.276796 L163.727273,455.276796 L163.727273,456.337574 C163.727273,458.374729 162.134664,459.987371 160.122869,459.987371 L121.877131,459.987371 C119.865336,459.987371 118.272727,458.374729 118.272727,456.337574 L118.272727,455.276796 Z M136.046165,462.28872 L145.953835,462.28872 L148.492898,466.981316 L133.507102,466.981316 L136.046165,462.28872 Z",
    id: "nb_wifi_desktop"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbWifiDesktop);
export default __webpack_public_path__ + "static/media/nb-wifi-desktop.a0698bc9cddcefd94ff9c34eb1b5b438.svg";
export { ForwardRef as ReactComponent };